import { FC } from "react";

import { useFrontendAuctionContext } from "../../../contexts/FrontendAuctionContext";

import { FormTypography } from "@/forms-design-system/FormTypography";
import { useTranslate } from "@/hooks/useTranslate";

export const AuctionWelcomeBack: FC = () => {
  const { t } = useTranslate();
  const { hasAlreadyBid, existingCommand } = useFrontendAuctionContext();

  if (!existingCommand || !hasAlreadyBid) {
    return null;
  }

  return (
    <FormTypography variant="h6" vibe="intense">
      {t("ticketing", "welcomeBack", { firstName: existingCommand.firstName })}
    </FormTypography>
  );
};
